type Translate = (key: string, options?: Record<string, unknown>) => string;

/** Formatea segundos como "5 h 10 min" / "3 min" / "45 s" para mensajes al usuario. */
export function formatRetryTime(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  if (s >= 3600) {
    const h = Math.floor(s / 3600);
    const m = Math.round((s % 3600) / 60);
    return m > 0 ? `${h} h ${m} min` : `${h} h`;
  }
  if (s >= 60) {
    return `${Math.max(1, Math.ceil(s / 60))} min`;
  }
  return `${Math.max(1, s)} s`;
}

/**
 * Extrae un mensaje legible de un error de Axios. Si es un 429 estructurado de
 * Spotify ({code:'spotify_rate_limited', retry_after_s}), arma el aviso con el
 * tiempo real de espera; si no, devuelve el detail (si es string) o el fallback.
 */
export function spotifyErrorMessage(e: any, t: Translate, fallbackKey: string): string {
  const detail = e?.response?.data?.detail;
  if (e?.response?.status === 429 && detail && typeof detail === 'object') {
    if (detail.code === 'spotify_busy') {
      // Nuestro auto-límite: vamos despacio a propósito, no es un ban de Spotify.
      return t('musicSystem.playlists.detail.goingSlow');
    }
    if (detail.code === 'spotify_rate_limited') {
      return t('musicSystem.playlists.detail.rateLimited', {
        time: formatRetryTime(detail.retry_after_s || 0),
      });
    }
  }
  return (typeof detail === 'string' ? detail : '') || t(fallbackKey);
}
